module.exports = __webpack_public_path__ + "static/img/12en.74799d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/sanxing/12en.png
// module id = Tt7b
// module chunks = 0